import { toast } from "sonner";
import { api, formatError, formatDate, useApi } from "@/lib/api";
import { AdminTitle, Table } from "./AdminUi";

const LABEL = { yes: "Yes", partly: "Partly", not_yet: "Not yet" };

export default function AdminFeedback() {
  const { data, reload } = useApi("/admin/feedback");
  const remove = async (id) => {
    if (!window.confirm("Delete this feedback?")) return;
    try { await api.delete(`/admin/feedback/${id}`); toast.success("Feedback deleted"); reload(); } catch (e) { toast.error(formatError(e)); }
  };
  const counts = (data || []).reduce((acc, f) => ({ ...acc, [f.journey]: { ...(acc[f.journey] || {}), [f.rating]: ((acc[f.journey] || {})[f.rating] || 0) + 1 } }), {});
  return (
    <div data-testid="admin-feedback">
      <AdminTitle title="Journey feedback">Anonymous answers to “Did this help you find a way forward?”. No names, emails or IP addresses are stored. Entries are deleted automatically after 12 months. Delete any comment that contains personal details.</AdminTitle>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 mb-6">
        {Object.entries(counts).map(([j, c]) => (
          <div key={j} className="card-soft !bg-white p-4 text-sm" data-testid={`feedback-summary-${j}`}><p className="font-semibold">{j}</p><p className="text-ink-soft">Yes {c.yes || 0} · Partly {c.partly || 0} · Not yet {c.not_yet || 0}</p></div>
        ))}
      </div>
      <Table head={["Date", "Journey", "Answer", "Comment", ""]} testId="feedback-table">
        {(data || []).map((f) => (
          <tr key={f.id}>
            <td className="px-4 py-3 whitespace-nowrap">{formatDate(f.created_at)}</td>
            <td className="px-4 py-3">{f.journey}</td>
            <td className="px-4 py-3">{LABEL[f.rating]}</td>
            <td className="px-4 py-3 max-w-md whitespace-pre-wrap">{f.comment || "—"}</td>
            <td className="px-4 py-3"><button className="btn-ghost !text-clay-dark" onClick={() => remove(f.id)} data-testid={`feedback-delete-${f.id}`}>Delete</button></td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
